export default __webpack_public_path__ + "media/images/logo-07167dd422bb81203de8af4f7d7394df.svg";